(() => {
  const TEST_VERSION = 'catalog-intent-v1-14d';
  const PENDING_KEY = 'keast-intent:pending-specialist-form';
  const MAX_PENDING_AGE_MS = 15 * 60 * 1000;
  const MAX_READY_ATTEMPTS = 20;
  const PRIVACY_FEATURE = [{ name: 'consent-tracking-api', version: '0.1' }];
  let readyAttempts = 0;
  let privacyFeatureRequested = false;

  if (window.location.pathname !== '/pages/thank-you') return;
  if (new URLSearchParams(window.location.search).get('lead_form') !== '642806') return;

  const readPending = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const clearPending = () => {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (_error) {
      // No personal or form data is stored. An unavailable session store simply
      // prevents this success event from being measured.
    }
  };

  const validPending = (pending) =>
    pending &&
    pending.test_version === TEST_VERSION &&
    pending.storefront_class === 'equipment' &&
    /^\d+$/.test(String(pending.product_id || '')) &&
    /^\d+$/.test(String(pending.variant_id || '')) &&
    String(pending.page_path || '').startsWith('/products/') &&
    Number.isFinite(Number(pending.submitted_at)) &&
    Date.now() - Number(pending.submitted_at) >= 0 &&
    Date.now() - Number(pending.submitted_at) <= MAX_PENDING_AGE_MS;


  // Separate reporting only. No new page-view/config tag or existing event edit.
  const reportQualification = (pending) => {
    const quality = pending.qualification;
    const states = new Set(['buying_inquiry', 'parts_inquiry', 'rental_inquiry', 'service_inquiry',
      'vendor_or_spam', 'other_inquiry', 'uncertain', 'test', 'out_of_scope']);
    const reasons = new Set(['not_equipment_product', 'rental_product', 'message_too_long', 'insufficient_detail',
      'labeled_test', 'classification_directive', 'promotional_message', 'employment', 'mixed_purpose',
      'parts_request', 'rental_request', 'service_request', 'supplier_request', 'purchase_negated',
      'purchase_interest', 'availability_question', 'price_question', 'delivery_question',
      'finance_question', 'application_question', 'insufficient_buying_context']);
    if (!quality || quality.version !== 'equipment-form-quality-v1' || quality.method !== 'rules-v1' ||
        !states.has(quality.status) || !reasons.has(quality.reason) ||
        !/^qf-[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(String(quality.id || '')) ||
        !/^\/products\/[a-z0-9][a-z0-9-]*\/?$/.test(String(pending.page_path || '')) ||
        !Array.isArray(window.dataLayer)) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy?.analyticsProcessingAllowed?.() !== true) return;
    const isTest = quality.is_test === true || quality.status === 'test' ||
      ['gtm_debug', 'gtm_preview', 'preview_theme_id', 'preview_token', 'codex_test',
        'keast_qa', 'qa_test', 'keast_tracking_test', 'test_event_code'].some(key => new URLSearchParams(window.location.search).has(key));
    const sentKey = `keast-form-quality:sent:${quality.id}`;
    try {
      if (window.sessionStorage.getItem(sentKey) === '1') return;
      window.sessionStorage.setItem(sentKey, '1');
    } catch (_error) {
      return;
    }
    const details = {
      send_to: 'G-T4X2J6DRGM',
      form_id: '642806',
      qualification_status: quality.status,
      qualification_reason: quality.reason,
      qualification_method: quality.method,
      qualification_version: quality.version,
      product_id: String(pending.product_id),
      variant_id: String(pending.variant_id),
      page_path: String(pending.page_path),
      event_id: quality.id,
      ...(isTest ? { debug_mode: true, qa_version: 'equipment-form-quality-v1-qa' } : {}),
    };
    function send() { window.dataLayer.push(arguments); }
    send('event', 'keast_form_qualification', details);
    if (!isTest && quality.status === 'buying_inquiry' &&
        privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true) {
      send('event', 'conversion', {
        send_to: 'AW-925584602/xXnqCOrhvqgdENqZrbkD',
        transaction_id: quality.id,
        value: 0,
        currency: 'USD',
      });
    }
  };

  const publishSuccess = () => {
    const pending = readPending();
    if (!validPending(pending)) {
      clearPending();
      return;
    }

    const analyticsAllowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed;
    const publish = window.Shopify?.analytics?.publish;
    const loadFeatures = window.Shopify?.loadFeatures;
    if (typeof analyticsAllowed !== 'function' && typeof loadFeatures === 'function' && !privacyFeatureRequested) {
      privacyFeatureRequested = true;
      loadFeatures(PRIVACY_FEATURE, (error) => {
        if (error) clearPending();
        else publishSuccess();
      });
      return;
    }
    if (typeof analyticsAllowed !== 'function' || typeof publish !== 'function') {
      readyAttempts += 1;
      if (readyAttempts < MAX_READY_ATTEMPTS) window.setTimeout(publishSuccess, 250);
      else clearPending();
      return;
    }

    if (analyticsAllowed() !== true) {
      clearPending();
      return;
    }

    const payload = {
      product_id: String(pending.product_id),
      variant_id: String(pending.variant_id),
      storefront_class: 'equipment',
      page_path: String(pending.page_path),
      test_version: TEST_VERSION,
    };

    publish('keast_specialist_form_success', payload);
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'keast_specialist_form_success', ...payload });
    }
    try {
      reportQualification(pending);
    } catch (_qualificationError) {
      // Reporting failure must not change the existing accepted-success event.
    }
    clearPending();
  };

  publishSuccess();
})();
